<template>
  <div>
    <b-badge
      v-for="tag in filteredEntityTags"
      :key="tag.id"
      :style="{ 'background-color': tag.color, 'color': getTextColor(tag.color) }"
      class="mr-1"
      pill
      variant="light"
    >
      {{ tag.name }}
    </b-badge>

    <b-badge
      v-b-modal="`tagsmodal${entityType}${entityId}`"
      pill
      role="button"
      variant="info"
      @mouseleave="showAddButtonText = false"
      @mouseover="showAddButtonText = true"
    >
      <font-awesome-icon :icon="['fal','plus']" class="fa-icon"></font-awesome-icon>

      <span v-if="showAddButtonText">
        {{ $t('tag.addtag')}}
      </span>
    </b-badge>

    <b-modal
      :id="`tagsmodal${entityType}${entityId}`"
      hide-footer
    >
      <template #modal-title>
        {{ $t('tag.manage')}}
      </template>

      <div class="d-block">
        <div
          v-for="tag in siteTags"
          :key="tag.id"
          class="row border-bottom py-2 d-flex align-items-center"
        >
          <div class="col-1">
            <div
              :style="{ 'background-color': tag.color }"
              style="height: 1em; width: 1em; display: inline-block"
            >
            </div>
          </div>
          <div class="col-8">
            {{ tag.name }}

            <b-button
              :title="$t('tag.edit_tag')"
              class="p-0 ml-1 d-inline-block"
              size="sm"
              variant="link"
              @click="editTag(tag)"
            >
              <span class="icon">
                  <font-awesome-icon :icon="['fal','edit']" class="icon"></font-awesome-icon>
              </span>
              <span class="visuallyhidden">
                {{ $t('tag.edit_tag') }}
              </span>
            </b-button>

            <b-button
              :title="$t('tag.delete_tag')"
              class="p-0 ml-1 d-inline-block"
              size="sm"
              variant="link"
              @click="deleteTag(tag.id)"
            >
              <span class="icon">
                  <font-awesome-icon :icon="['fal','trash']" class="icon text-danger"></font-awesome-icon>
              </span>
              <span class="visuallyhidden">
                {{ $t('tag.delete_tag') }}
              </span>
            </b-button>
          </div>
          <div class="col-3 text-right">
            <b-form-checkbox
              v-model="tag.state"
              class="bmswitch"
              v-on:change="switchAssignment(tag.id)"
            ></b-form-checkbox>
          </div>
        </div>

        <div class="row pt-1">
          <div class="col-11 offset-1">
            <b-button
              class="p-0"
              size="sm"
              variant="link"
              @click="openCreateDialog()"
            >
              + {{ $t('tag.create_tag') }}
            </b-button>
          </div>
        </div>
      </div>

      <div class="d-block text-right mt-3">
        <b-button
          variant="success"
          @click="$bvModal.hide(`tagsmodal${entityType}${entityId}`)"
        >
          {{ $t('tag.ok') }}
        </b-button>
      </div>
    </b-modal>

    <b-modal
      :id="`tagscreatemodal${entityType}${entityId}`"
      hide-footer
    >
      <template #modal-title>
        {{ $t('tag.create_new')}}
      </template>

      <b-form @submit="createTag">
        <div class="d-block">
          <b-row>
            <b-col>
              <b-form-group :label="$t('tag.form.tag_name')">
                <b-form-input
                  v-model="tagData.name"
                  name="tag_name"
                  required
                  type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('tag.form.color')">
                <b-form-input
                  v-model="tagData.color"
                  name="color"
                  required
                  type="color"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                v-model="tagData.in_sidebar"
                name="in_sidebar"
              >
                {{ $t('tag.form.in_sidebar') }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </div>

        <div class="d-block text-right mt-3">
          <b-button
            type="submit"
            variant="success"
          >
            <span class="icon">
                <font-awesome-icon :icon="['fal','save']" class="icon"></font-awesome-icon>
            </span>
            {{ $t('tag.form.save') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      :id="`tagseditmodal${entityType}${entityId}`"
      hide-footer
    >
      <template #modal-title>
        {{ $t('tag.edit_tag')}}
      </template>

      <b-form @submit="updateTag">
        <div class="d-block">
          <b-row>
            <b-col>
              <b-form-group :label="$t('tag.form.tag_name')">
                <b-form-input
                  v-model="tagData.name"
                  name="tag_name"
                  required
                  type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('tag.form.color')">
                <b-form-input
                  v-model="tagData.color"
                  name="color"
                  required
                  type="color"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                v-model="tagData.in_sidebar"
                name="in_sidebar"
              >
                {{ $t('tag.form.in_sidebar') }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </div>

        <div class="d-block text-right mt-3">
          <b-button
            type="submit"
            variant="success"
          >
            <span class="icon">
                <font-awesome-icon :icon="['fal','save']" class="icon"></font-awesome-icon>
            </span>
            {{ $t('tag.form.save') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>

import { mapState } from 'vuex'

import { getTextColorForBackground } from '../../services/colors'

export default {
  name: 'TagList',

  props: [
    'entityTags',
    'entityType',
    'entityId'
  ],

  data () {
    return {
      showAddButtonText: false,
      siteTags: [],
      tagData: {}
    }
  },

  computed: {
    ...mapState('site', [
      'siteDetail'
    ]),
    ...mapState('tag', {
      tagList: state => state.tags
    }),
    filteredEntityTags: function () {
      return this.entityTags.filter((entityTag) => {
        return this.tagList.find(tag => tag.id === entityTag.id)
      })
    }
  },

  methods: {
    getTextColor (background) {
      return getTextColorForBackground(background)
    },
    siteHasTag (tagId) {
      return this.entityTags.filter((tag) => {
        return tag.id === tagId
      }).length > 0
    },
    buildSiteTagList () {
      this.siteTags.splice(0)

      for (let tag of this.tagList) {
        tag.state = this.siteHasTag(tag.id)
        this.siteTags.push({ ...tag })
      }
    },
    switchAssignment (tagId) {
      this.$store.dispatch('tag/switchAssignment', {
        id: tagId,
        entity_id: this.entityId,
        entity_type: this.entityType
      }).then((result) => {
        this.$emit('updatedTags', result)
        this.$store.dispatch('site/getAllSites')
      })
    },
    openCreateDialog () {
      this.$bvModal.hide(`tagsmodal${this.entityType}${this.entityId}`)
      this.$bvModal.show(`tagscreatemodal${this.entityType}${this.entityId}`)
      this.tagData = {}
    },
    createTag (event) {
      event.preventDefault()

      this.$store.dispatch('tag/createTag', this.tagData)
        .then(() => {
          this.tagData = {}
          this.$snotify.success('Tag created successfully')

          this.$bvModal.show(`tagsmodal${this.entityType}${this.entityId}`)
          this.$bvModal.hide(`tagscreatemodal${this.entityType}${this.entityId}`)
        })
    },
    editTag (tag) {
      this.tagData = tag

      this.$bvModal.hide(`tagsmodal${this.entityType}${this.entityId}`)
      this.$bvModal.show(`tagseditmodal${this.entityType}${this.entityId}`)
    },
    updateTag (event) {
      event.preventDefault()

      this.$store.dispatch('tag/updateTag', this.tagData)
        .then(() => {
          this.tagData = {}
          this.$snotify.success('Tag updated successfully')

          this.$bvModal.show(`tagsmodal${this.entityType}${this.entityId}`)
          this.$bvModal.hide(`tagseditmodal${this.entityType}${this.entityId}`)
        })
    },
    deleteTag (tagId) {
      this.$store.dispatch('tag/deleteTag', tagId)
        .then(() => {
          this.$snotify.success('Tag deleted successfully')
        })
    }
  },

  watch: {
    'tags': function () {
      this.buildSiteTagList()
    },
    'tagList': function () {
      this.buildSiteTagList()
    }
  },

  mounted () {
    this.buildSiteTagList()
  }
}
</script>
